/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiLastRunInfoFromJSON, ApiLastRunInfoToJSON, } from './ApiLastRunInfo';
export function ApiLastRunInfoResponseFromJSON(json) {
    return ApiLastRunInfoResponseFromJSONTyped(json, false);
}
export function ApiLastRunInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'lastRunInfo': !exists(json, 'lastRunInfo') ? undefined : ApiLastRunInfoFromJSON(json['lastRunInfo']),
    };
}
export function ApiLastRunInfoResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'lastRunInfo': ApiLastRunInfoToJSON(value.lastRunInfo),
    };
}
